import { render, staticRenderFns } from "./xingfu.vue?vue&type=template&id=72d490e9&scoped=true"
import script from "./xingfu.vue?vue&type=script&lang=js"
export * from "./xingfu.vue?vue&type=script&lang=js"
import style0 from "./xingfu.vue?vue&type=style&index=0&id=72d490e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d490e9",
  null
  
)

export default component.exports